import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

//const baseURL = "http://localhost:8080/"; //Desarrollo
// const baseURL = "http://192.168.50.126:8080/"; //Desarrollo Mobil

// const baseURL = "http://91.126.218.179:8888/"; //SERV-ATIN02

//const baseURL = "http://188.85.141.50:8087/"; //Real

const baseURL = "https://pedidos.olimpogourmet.com:8083/"; //Real


axios.defaults.baseURL = baseURL
Vue.use(VueAxios, axios)